<script setup lang="ts">
import VTopics from '~/components/topics/VTopics.vue';

useHead({
  title: 'Темы проектов',
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: 'Темы индивидуальных проектов для студентов и школьников 5, 6, 7, 8, 9, 10, 11 класс.',
    },
    {
      property: 'og:title',
      content: 'Темы проектов',
    },
    {
      property: 'og:description',
      content: 'Темы индивидуальных проектов для студентов и школьников 5, 6, 7, 8, 9, 10, 11 класс.',
    },
  ],
});
</script>

<template>
  <div class="topics-page">
    <v-topics />
  </div>
</template>

<style scoped lang="scss">
.topics-page {
  display: grid;
  min-height: 100vh;
  grid-template-rows: auto 1fr auto;
}
</style>
